import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getEstados,
  getEstadosMensajeria,
  insertEstado,
  updateEstado,
  deleteEstado,
  updateEstadoMensajeria,
  deleteEstadoMensajeria,
  insertEstadoMensajeria,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_ESTADOS() {
  try {
    const estadosData = yield call(getEstados)
    if (estadosData.ok) {
      yield put({
        type: actions.ESTADOS_LOAD_SUCCEEDED,
        payload: estadosData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar estados')
      put({
        type: actions.ESTADOS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ESTADOS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ESTADOS_MENSAJERIA() {
  try {
    const estadosMensajeriaData = yield call(getEstadosMensajeria)
    if (estadosMensajeriaData.ok) {
      yield put({
        type: actions.ESTADOS_MENSAJERIA_LOAD_SUCCEEDED,
        payload: estadosMensajeriaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar estados mensajeria')
      put({
        type: actions.ESTADOS_MENSAJERIA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ESTADOS_MENSAJERIA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_ESTADO(action) {
  try {
    const estadoObj = yield call(insertEstado, action.payload)
    if (estadoObj.ok) {
      putMessage(messageType.SUCCESS, 'Estado creado correctamente')
      yield put({
        type: actions.ESTADO_INSERT_SUCCEEDED,
        payload: estadoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Estado')
      yield put({
        type: actions.ESTADO_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Estado')
    yield all([
      put({
        type: actions.ESTADO_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ESTADO(action) {
  try {
    const estadoObj = yield call(updateEstado, action.payload)
    if (estadoObj.ok) {
      putMessage(messageType.SUCCESS, 'Estado modificado correctamente')
      yield put({
        type: actions.ESTADO_UPDATE_SUCCEEDED,
        payload: estadoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Estado')
      yield put({
        type: actions.ESTADO_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Estado')
    yield all([
      put({
        type: actions.ESTADO_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ESTADO(action) {
  try {
    const estadoResult = yield call(deleteEstado, action.payload)
    if (estadoResult.ok) {
      putMessage(messageType.SUCCESS, 'Estado eliminado correctamente')
      yield put({
        type: actions.ESTADO_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Estado')
      yield put({
        type: actions.ESTADO_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Estado')
    yield all([
      put({
        type: actions.ESTADO_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_ESTADO_MENSAJERIA(action) {
  try {
    const estadoMensajeriaObj = yield call(insertEstadoMensajeria, action.payload)
    if (estadoMensajeriaObj.ok) {
      putMessage(messageType.SUCCESS, 'Estado Mensajeria creado correctamente')
      yield put({
        type: actions.ESTADO_MENSAJERIA_INSERT_SUCCEEDED,
        payload: estadoMensajeriaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Estado Mensajeria')
      yield put({
        type: actions.ESTADO_MENSAJERIA_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Estado Mensajeria')
    yield all([
      put({
        type: actions.ESTADO_MENSAJERIA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ESTADO_MENSAJERIA(action) {
  try {
    const estadoMensajeriaObj = yield call(updateEstadoMensajeria, action.payload)
    if (estadoMensajeriaObj.ok) {
      putMessage(messageType.SUCCESS, 'Estado Mensajeria modificado correctamente')
      yield put({
        type: actions.ESTADO_MENSAJERIA_UPDATE_SUCCEEDED,
        payload: estadoMensajeriaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Estado Mensajeria')
      yield put({
        type: actions.ESTADO_MENSAJERIA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Estado Mensajeria')
    yield all([
      put({
        type: actions.ESTADO_MENSAJERIA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ESTADO_MENSAJERIA(action) {
  try {
    const estadoMensajeriaResult = yield call(deleteEstadoMensajeria, action.payload)
    if (estadoMensajeriaResult.ok) {
      putMessage(messageType.SUCCESS, 'Estado Mensajeria eliminado correctamente')
      yield put({
        type: actions.ESTADO_MENSAJERIA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Estado Mensajeria')
      yield put({
        type: actions.ESTADO_MENSAJERIA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Estado Mensajeria')
    yield all([
      put({
        type: actions.ESTADO_MENSAJERIA_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.ESTADOS_LOAD_REQUESTED, GET_ESTADOS),
    takeEvery(actions.ESTADOS_MENSAJERIA_LOAD_REQUESTED, GET_ESTADOS_MENSAJERIA),
    takeEvery(actions.ESTADO_INSERT_REQUESTED, INSERT_ESTADO),
    takeEvery(actions.ESTADO_UPDATE_REQUESTED, UPDATE_ESTADO),
    takeEvery(actions.ESTADO_DELETE_REQUESTED, DELETE_ESTADO),
    takeEvery(actions.ESTADO_MENSAJERIA_INSERT_REQUESTED, INSERT_ESTADO_MENSAJERIA),
    takeEvery(actions.ESTADO_MENSAJERIA_UPDATE_REQUESTED, UPDATE_ESTADO_MENSAJERIA),
    takeEvery(actions.ESTADO_MENSAJERIA_DELETE_REQUESTED, DELETE_ESTADO_MENSAJERIA),
  ])
}
